import { render, staticRenderFns } from "./dataTime.vue?vue&type=template&id=0f0a5d09&scoped=true"
import script from "./dataTime.vue?vue&type=script&lang=js"
export * from "./dataTime.vue?vue&type=script&lang=js"
import style0 from "./dataTime.vue?vue&type=style&index=0&id=0f0a5d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a5d09",
  null
  
)

export default component.exports